import { UserInfo } from "../types/domain/User";

import useAxiosConfig from "./useAxiosConfig";
import useAxiosHeader from "./useAxiosHeader";

const useExternalAxiosConfig = (
  userData: UserInfo | null | undefined,
  setData: (data: any) => void,
  apiBaseUrl?: string,
  refreshTokenUrl?: string,
  companyId?: number,
  forbiddenCallback?: () => void,
  sessionId?: string,
  clientId?: string,
  refreshTokenBaseUrl?: string
) => {
  useAxiosHeader("X-Company-Id", companyId);
  useAxiosHeader("X-Session-Id", sessionId);

  return useAxiosConfig(
    userData,
    setData,
    apiBaseUrl,
    refreshTokenUrl,
    false,
    clientId,
    forbiddenCallback,
    refreshTokenBaseUrl
  );
};

export default useExternalAxiosConfig;
